import type {PayloadAction} from "@reduxjs/toolkit";
import {createSlice} from "@reduxjs/toolkit";
import type {AppThunk} from "../store";
import {HYDRATE} from "next-redux-wrapper";

export interface RateUserProfile {
    firstName: string;
    photoUrl: string;
    username: string;
    uid: string;
    photoHash: string;
}

export interface RateUserFormData {
    lastDiveTogetherYear: string;
    lastDiveTogetherMonth: string;
    attitude: string;
    skills: string;
    deserves: string;
}

export interface RateUserState {
    rateUserProfile: RateUserProfile;
    rateUserFormData: RateUserFormData;
}

const initialState: RateUserState = {
    rateUserProfile: {
        firstName: "",
        photoUrl: "",
        username: "",
        uid: "",
        photoHash: "",
    },
    rateUserFormData: {
        lastDiveTogetherMonth: "",
        lastDiveTogetherYear: "",
        skills: "",
        attitude: "",
        deserves: "",
    },
};

const rateUserSlice = createSlice({
    name: "rateUser",
    initialState,
    reducers: {
        setRateUserProfile(state: RateUserState, action: PayloadAction<RateUserProfile>): void {
            state.rateUserProfile = {...state.rateUserProfile, ...action.payload};
        },
        setRateUserFormData(state: RateUserState, action: PayloadAction<RateUserFormData>): void {
            state.rateUserFormData = {...state.rateUserFormData, ...action.payload};
        }
    },
    extraReducers: (builder) => {
        builder.addCase(HYDRATE, (state, action: any) => {
            return {
                ...state,
                ...action.payload.rateUser,
            };
        });
    },
});

export const {setRateUserProfile, setRateUserFormData} = rateUserSlice.actions;

export default rateUserSlice

// Thunks (unchanged except for AppThunk typing)
export const setRateUserProfileThunk =
    (rateUserProfile: RateUserProfile): AppThunk =>
        async (dispatch): Promise<void> => {
            dispatch(setRateUserProfile(rateUserProfile));
        };

export const setFamiliarityData =
    (lastDiveTogetherMonth: string, lastDiveTogetherYear: string): AppThunk =>
        async (dispatch, getState): Promise<void> => {

            dispatch(
                setRateUserFormData({
                    ...getState().rateUser.rateUserFormData,
                    lastDiveTogetherMonth,
                    lastDiveTogetherYear,
                })
            );
        };

export const setAttitudeData =
    (attitude: string): AppThunk =>
        async (dispatch, getState): Promise<void> => {
            dispatch(
                setRateUserFormData({
                    ...getState().rateUser.rateUserFormData,
                    attitude,
                })
            );
        };

export const setSkillsData =
    (skills: string): AppThunk =>
        async (dispatch, getState): Promise<void> => {
            dispatch(
                setRateUserFormData({
                    ...getState().rateUser.rateUserFormData,
                    skills,
                })
            );
        };

export const setDeservesData =
    (deserves: string): AppThunk =>
        async (dispatch, getState): Promise<void> => {
            dispatch(
                setRateUserFormData({
                    ...getState().rateUser.rateUserFormData,
                    deserves,
                })
            );
        };
